import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getVerify(id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/${Crypto.encrypt(id, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  createVerify(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify`;
    return httpPost(apiUrl, data);
  }

  modifyVerify(id, data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/${Crypto.encrypt(id, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }

  fakeDeleteVerify(id, data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/fakeDelete/${Crypto.encrypt(id, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }

  deleteVerify(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  getVerifyByPet(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/pet/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  getVerifyListByPet(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/getPetList`;
    return httpPost(apiUrl, options);
  }

  getVerifyList(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/verify/getList`;
    return httpPost(apiUrl, options);
  }
}
